import type { FC } from "react";
import Campaign from "~/components/campaign";
import Metadata from "~/components/metadata";

const CampaignPage: FC = () => (
  <>
    <Metadata
      pageTitle="Advante Campaign"
      title="Campaign"
      description="Campaign"
      canonical="https://advante.co/campaign"
    />
    <Campaign />
  </>
);

export default CampaignPage;
